// IconButton primitive — the design's three icon-button shapes:
//  round  46px circle   (call controls: mic/cam/share/react/hand/rec/more)
//  square 44px radius-12 (panel toggles: files/people/chat)
//  flat   30px radius-8  (inline row actions: download, close, cal nav)
// Stateful tints (active/danger/warning) come from the `tone` prop.

import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type IconButtonShape = 'round' | 'square' | 'flat';
export type IconButtonTone = 'default' | 'active' | 'danger' | 'warning';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  shape?: IconButtonShape;
  tone?: IconButtonTone;
  /** Accessible name; also the hover tooltip. */
  label: string;
  children?: ReactNode;
}

export function IconButton({ shape = 'round', tone = 'default', label, className, ...rest }: Props) {
  const cls = ['bz-iconbtn', `bz-iconbtn-${shape}`, `bz-iconbtn-${tone}`, className ?? '']
    .filter(Boolean)
    .join(' ');
  return <button type="button" className={cls} title={label} aria-label={label} {...rest} />;
}
